module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_blue_05-612ff457fbf702ca4a50ee41bcad4504.svg";